import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface Invoice {
  number: string | null
  /** YYYY-MM-DD */
  date: string
  /** cents */
  amount: number
  currency: string
  status: 'open' | 'paid' | 'uncollectible' | 'void'
  hosted_invoice_url: string | null
  invoice_pdf: string | null
}

export const invoicesQueryKey = (teamId?: string | number | null) => [
  'billing-invoices',
  teamId ?? null,
]

/** Invoices for this space's subscriptions. Owner only. */
export default function useGetInvoices({
  teamId,
  enabled = true,
}: {
  teamId?: string | number | null
  enabled?: boolean
}) {
  return useQuery<Invoice[]>({
    queryKey: invoicesQueryKey(teamId),
    queryFn: async () => {
      const response = await httpClient.get('billing/invoices', {
        headers: teamId ? { 'X-Team': String(teamId) } : undefined,
      })
      return response.data
    },
    enabled: enabled && !!teamId,
    staleTime: 5 * 60 * 1000,
  })
}
